export default __webpack_public_path__ + "static/media/notifications-EN.c500b969.png";